import DuplicateOrdersModal from './DuplicateOrdersModal.container'

export default DuplicateOrdersModal
